<template>
  <div class="poprun_header_page">
    <div class="logo_box">
      <img
        @click="goShequ"
        :style="{ width: '3.1875rem', height: '3.1875rem', cursor: 'pointer' }"
        src="@/assets/images/m/logo.png"
        alt="logo"
      />
    </div>
    <div class="right_setting">
      <img
        src="@/assets/images/m/icon-username.png"
        alt="user"
        :style="{ cursor: 'pointer' }"
        @mouseenter="showMenu"
      />

      <div v-if="visible" @mouseleave="hideMenu">
        <div class="menu-container" v-if="isLogin">
          <div
            v-if="userInfo.username"
            :style="{
              marginBottom: '.5625rem',
              fontSize: '1.5625rem',
              color: '#F2F2F7',
              lineHeight: '2.0625rem',
              textAlign: 'center',
            }"
          >
            {{ userInfo.username }}
          </div>
          <div
            v-if="userInfo.username"
            :style="{ width: '100%', border: '.0625rem dashed #333' }"
          ></div>
          <div
            :style="{
              fontSize: '1.5625rem',
              color: '#F2F2F7',
              lineHeight: '2.0625rem',
              marginTop: '1.3125rem',
              cursor: 'pointer',
            }"
            @click="goPersonal"
          >
            {{ $t("Personal page") }}
          </div>
          <div
            v-if="isRaceAdmin"
            :style="{
              fontSize: '1.4375rem',
              color: '#F2F2F7',
              lineHeight: '2.0625rem',
              margin: '.75rem 0',
              display: 'flex',
              alignItems: 'center',
            }"
          >
            <div
              :style="{
                cursor: 'pointer',
              }"
              @click="handleJumpPage(PAGE_REVIEW)"
            >
              {{ $t("end.application") }}
            </div>
            <div
              :style="{
                minWidth: '4.375rem',
                height: '2.125rem',
                textAlign: 'center',
                background: '#FF6900',
                borderRadius: '3.6875rem',
                cursor: 'pointer',
              }"
              @click="handleJumpPage(PAGE_REVIEW)"
            >
              {{ confirmingCount > 999 ? "999+" : confirmingCount }}
            </div>
          </div>
          <div
            :style="{
              fontSize: '1.5625rem',
              color: '#F2F2F7',
              lineHeight: '2.0625rem',
              cursor: 'pointer',
              marginTop: isRaceAdmin ? '0rem' : '1.6875rem',
            }"
            @click="logOut"
          >
            {{ $t("Sign out") }}
          </div>
        </div>
        <div class="menu-container-not-Login" v-else>
          <div
            :style="{
              fontSize: '1.5625rem',
              color: '#F2F2F7',
              textAlign: 'center',
              cursor: 'pointer',
            }"
            @click="login"
          >
            {{ $t("Sign in") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { goShare } from "@/plugins/share";
import { getClickMapParams, handleJumpPage } from "@/utils";
import {
  PAGE_REVIEW,
  PAGE_PERSONAL,
  isLogin,
  PAGE_HOME,
  PAGE_DETAILS,
  PAGE_REGISTER,
  PAGE_REGISTRATION_ENDS,
} from "@/utils/constant";
import { mapState } from "vuex";
export default {
  name: "poprun_header_page",
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  data() {
    return {
      isLogin,
      visible: false,
      confirmingCount: null,
      isRaceAdmin: null,
      PAGE_REVIEW,
      PAGE_PERSONAL,
    };
  },
  created() {
    this.handleJumpPage = handleJumpPage;
    this.countConfirmParticipants();
  },
  methods: {
    goPersonal() {
      this.$route.path.includes(PAGE_HOME) &&
        getClickMapParams("home_personalcenter", {
          open_url: PAGE_PERSONAL,
          open_page: "poprun_personalpage",
          button_name: this.$t("Personal page"),
        });
      handleJumpPage(PAGE_PERSONAL);
    },
    login() {
      if (isLogin) {
        handleJumpPage(PAGE_PERSONAL);
      } else {
        const followup =
          process.env.VUE_APP_SERVICE_API + "/poprun/global/personal.html";
        location.href = `${process.env.VUE_APP_BACKEND_API}/open/api/login?followup=${followup}`;
      }
    },
    logOut() {
      if (isLogin) {
        sessionStorage.clear();
        const followup =
          process.env.VUE_APP_SERVICE_API + "/poprun/global/index.html";
        location.href = `${process.env.VUE_APP_BACKEND_API}/open/api/logout?callBackUrl=${followup}`;
      }
    },
    async countConfirmParticipants() {
      const { data = {} } = await this.$api.countConfirmParticipants({});
      const { confirmingCount = 0, isRaceAdmin = false } = data;
      this.isRaceAdmin = isRaceAdmin;
      this.confirmingCount = confirmingCount;
    },
    showMenu() {
      this.visible = true;
    },
    hideMenu() {
      this.visible = false;
    },
    goShequ() {
      const url = "https://mi.com";
      getClickMapParams(
        {
          [PAGE_HOME]: "home_header",
          [PAGE_DETAILS]: "details_header",
          [PAGE_REGISTER]: "register_header",
          [PAGE_REGISTRATION_ENDS]: "success_header",
          [PAGE_PERSONAL]: "personalpage_header",
        }[this.$route.path.replace("/" + this.$i18n.locale + "/", "")],
        {
          open_url: url,
          open_page: "out_community",
          button_name: "",
        }
      );
      goShare(url);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/css/common";
.poprun_header_page {
  width: 100%;
  position: absolute;
  top: 0rem;
  left: 0rem;
  padding: 1.75rem;
  display: flex;
  justify-content: space-between;
  z-index: 100;

  .right_setting {
    position: relative;
    .me_user {
      width: 2.5rem;
      height: 2.5rem;
      display: block;
    }
    img {
      width: 3.125rem;
      height: 3.125rem;
    }
    .menu-container {
      position: absolute;
      width: 16.5625rem;
      background: #161616;
      border-radius: 0.5rem;
      right: 0;
      padding: 0.8125rem 1.375rem 1.3125rem;
    }
    .menu-container-not-Login {
      position: absolute;
      width: 13.875rem;
      height: 3.25rem;
      background: #161616;
      border-radius: 0.5rem;
      right: 0;
      padding: 0 1.375rem;
      line-height: 3.25rem;
    }
  }
}
</style>
